import * as React from 'react';
import { DataStore } from './DataStore'


export const dataStore = new DataStore();

export const storesContext = React.createContext({
    dataState: dataStore,
    uiState: dataStore.uiState,
})